import React from 'react'
import moment from 'moment'

moment.locale('fr')


export default props => {
  return <div>AHAHAHAH</div>
}



// WEBPACK FOOTER //
// ./app/App/Module/Page/Page/Test/index.js